import { render, staticRenderFns } from "./DevFAB.vue?vue&type=template&id=65f2b4fe"
import script from "./DevFAB.vue?vue&type=script&lang=js"
export * from "./DevFAB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports